import { useEffect, useState } from "react";
import { PhotoModalSecond } from "../molecules/ModalPhoto";

import Circle from "../../../assets/images/Modal/Frame_number11.png";
import CircleGray from "../../../assets/images/Modal/Frame_number2.png";
import ARROWRIGHT from "../../../../common/assets/images/Modal/Line 15.png";
import ARROWLEFT from "../../../../common/assets/images/Modal/Line 14.png";
import Wifi_Page_4_2 from "../../../../common/assets/images/Modal/WiFI_4_2.png";
import Page_3_1 from "../../../../common/assets/images/Modal/Анализ-эффективности вер. 2.png";
import Page_5_1 from "../../../../common/assets/images/Modal/Эксплуатация-шпинделя.png";

import "../styles/modal.css";
import "../../ButtonLeftRight/styles/buttonleftright.css";
import "../../TableBlock/styles/tableblock.css";

import { IModalVideo, Ipoint2D } from "../../../interfaces";

import {
  $ReadenSlides_LeftSection,
  $ReadenSlides_RightSection,
  AddReadenSlide_LeftSection,
  AddReadenSlide_RightSection,
} from "../../GuideButtons/logic/GuideLogic";
import { useStore } from "effector-react";

export const Modal = ({
  active,
  setHover,
  image,
  points,
  list,
  title,
  table,
  text,
  titletext,
  maxWidthTable,
  minWidthTable,
  shortTitle,
}: IModalVideo) => {
  const [forModal, setForModal] = useState({
    title: "",
    content: [""],
    text: [""],
    titletext: [""],
  });
  useEffect(() => {
    setAttachment(0);
  }, [active]);
  //Понимаю, что это вообще никак не поможет делать такие презентациии быстро, но для включения внутренних маркеров
  //Мне придется делать все вот так, вручную.
  const leftSection = useStore($ReadenSlides_LeftSection);
  const rightSection = useStore($ReadenSlides_RightSection);

  const OnCountChange = (sign: string) => {
    if (sign === "+") {
      if (attachment === image.length - 1) {
        setAttachment(0);
      } else {
        setAttachment(attachment + 1);
      }
    } else {
      if (attachment === 0) {
        setAttachment(image.length - 1);
      } else {
        setAttachment(attachment - 1);
      }
    }
  };

  //перелистывание изображений клавишами
  onkeydown = (event) => {
    if (event.key === "ArrowRight" && active === true) {
      OnCountChange("+");
    } else if (event.key === "ArrowLeft" && active === true) {
      OnCountChange("-");
    }
  };
  const onMarkerClick = (marker: Ipoint2D, initial: number) => {
    if (
      title === "Левая секция" ||
      title === "Linke Sektionn" ||
      title === "Left section"
    ) {
      if (leftSection + 1 > initial) {
        setForModal({
          title: marker.title,
          content: marker.content,
          text: marker.text,
          titletext: marker.titletext,
        });
        setModalActiveSecond(true);
        if (leftSection === initial) AddReadenSlide_LeftSection();
      }
    }

    if (
      title === "Правая секция" ||
      title === "Rechte Sektion" ||
      title === "Right section"
    ) {
      if (rightSection + 1 > initial) {
        setForModal({
          title: marker.title,
          content: marker.content,
          text: marker.text,
          titletext: marker.titletext,
        });
        setModalActiveSecond(true);
        if (rightSection === initial) AddReadenSlide_RightSection();
      }
    }
    if (
      title !== "Правая секция" &&
      title !== "Rechte Sektion" &&
      title !== "Right section" &&
      title !== "Левая секция" &&
      title !== "Linke Sektionn" &&
      title !== "Left section"
    ) {
      setForModal({
        title: marker.title,
        content: marker.content,
        text: marker.text,
        titletext: marker.titletext,
      });
      setModalActiveSecond(true);
    }
  };

  // -------------------------------------------------------
  const [attachment, setAttachment] = useState(0);
  const [modalActiveSecond, setModalActiveSecond] = useState(false);

  //TODO:"С border ошибка какая-то"
  return (
    <div
      className={active ? "ph_modal_main" : "ph_modal_main_hidden"}
      onClick={(e) => {
        // e.stopPropagation();
        setHover(false);
      }}
    >
      <div
        className="ph_modal_content_second"
        style={
          table
            ? {
                flexDirection: "column",
                background: "white",
                backgroundColor: "white",
                padding: "1.5%",
                // width:"45vw",
                // height:"75vh",
                minWidth: `${
                  minWidthTable !== undefined ? minWidthTable : "0"
                }`,
                minHeight: "75vh",
                maxWidth: `${
                  maxWidthTable !== undefined ? maxWidthTable : "65vw"
                }`,
                maxHeight: "100vh",
              }
            : list
            ? {
                flexDirection: "row",
                minWidth: "35vw",
              }
            : points
            ? {
                flexDirection: "row",
                minWidth: "40vw",
              }
            : {
                flexDirection: "row",
                minWidth: `${
                  minWidthTable !== undefined ? minWidthTable : "50vw"
                }`,
              }
        }
        onClick={(e) => e.stopPropagation()}
      >
        {/*Стрелка влево, если нужна*/}
        {image.length > 1 && list?.length !== 0 && !table ? (
          <div className="ArrowBlockAllL ArrowBlockAll">
            <div className="ArrowBlockAll_NotCenter"></div>
            <div
              className="ArrowBlockAll_Center"
              onClick={() => OnCountChange("+")}
            >
              <img
                src={ARROWLEFT}
                className="ArrowBlockAll_Center_img"
                alt=""
              />
            </div>
            <div className="ArrowBlockAll_NotCenter"></div>
          </div>
        ) : null}
        {/*Стрелка влево, если нужна*/}
        {/*Контент*/}
        {list ? (
          <div
            className="ph_modal_adaptive"
            style={{
              backgroundColor: "white",
              zIndex: 5,
              justifyContent: "center",
            }}
          >
            {title ? (
              <h3
                className="ph_modal_title_main"
                style={{ paddingBottom: "1rem" }}
              >
                {title}
              </h3>
            ) : null}

            {image[0] !== "" ? (
              <img
                src={image[0]}
                alt=""
                onClick={(e) => e.stopPropagation()}
                className="modal_image"
                style={{ maxHeight: "40vh" }}
              />
            ) : null}

            {list?.map((e, i) => {
              return (
                <div key={i}>
                  <ul style={{ position: "relative", listStyle: "none" }}>
                    {e.quotes.map((e, i) => {
                      if (e.substring(0, 1) === "_") {
                        return <span key={i}>{e.substring(1, e.length)}</span>;
                      } else {
                        return (
                          <li key={i} className="ph_modal_li">
                            {e}
                          </li>
                        );
                      }
                    })}
                  </ul>
                </div>
              );
            })}
          </div>
        ) : points ? (
          <div style={{ height: "100%", backgroundColor: "white" }}>
            <h3
              className="ph_modal_title_main"
              style={{ paddingTop: "0.75rem" }}
            >
              {title}
            </h3>
            <div style={{ position: "relative", height: "90%" }}>
              <img
                src={image[0]}
                alt=""
                onClick={(e) => e.stopPropagation()}
                className="modal_image_points"
              />
              {points?.map((e, i) => {
                return (
                  <div
                    className="lastVariantButton"
                    aria-disabled={
                      title === "Левая секция" ||
                      title === "Linke Sektionn" ||
                      title === "Left section"
                        ? leftSection + 1 > i
                          ? false
                          : true
                        : title === "Правая секция" ||
                          title === "Rechte Sektion" ||
                          title === "Right section"
                        ? rightSection + 1 > i
                          ? false
                          : true
                        : false
                    }
                    onClick={() => onMarkerClick(e, i)}
                    key={i}
                    style={{ top: e.top, left: e.left }}
                  >
                    <span
                      style={{
                        position: "absolute",
                        zIndex: 2,
                        textAlign: "center",
                        color: "white",
                        left: "0",
                        right: "0",
                        fontWeight: 700,
                      }}
                    >
                      {e.id}
                    </span>

                    <img
                      className="withWaves"
                      style={{ height: "auto", width: "100%" }}
                      alt=""
                      // src={Circle}
                      src={
                        title === "Левая секция" ||
                        title === "Linke Sektionn" ||
                        title === "Left section"
                          ? leftSection + 1 > i
                            ? Circle
                            : CircleGray
                          : title === "Правая секция" ||
                            title === "Rechte Sektion" ||
                            title === "Right section"
                          ? rightSection + 1 > i
                            ? Circle
                            : CircleGray
                          : Circle
                      }
                    />
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <div
            style={{
              zIndex: 5,
              textAlign: "center",
              // maxWidth: "max-content",
              backgroundColor: "white",
              display: "flex",
              flexDirection: "column",
              margin: "-2px",
              width: "100%",
            }}
          >
            <div className="ph_modal_adaptive">
              <h3 className="ph_modal_title">{title}</h3>
              {image && image[0] !== "" ? (
                <img
                  className="ph_modal_image"
                  src={image ? image[attachment] : ""}
                  alt=""
                  style={
                    image[attachment] === Wifi_Page_4_2
                      ? { maxWidth: "35vw" }
                      : image[attachment] === Page_3_1 ||
                        image[attachment] === Page_5_1
                      ? { minWidth: "60vw" }
                      : { maxWidth: "" }
                  }
                />
              ) : null}
              {titletext && titletext[0] !== "" ? (
                <p className="text_format__title">
                  {titletext[0] !== undefined ? titletext[attachment] : null}
                </p>
              ) : null}
              {text && text[0] !== "" ? (
                <p className="text_format">
                  {text[0] !== undefined ? text[attachment] : null}
                </p>
              ) : null}
            </div>
          </div>
        )}

        {/*Контент*/}

        {/* Стрелка вправо, если нужна*/}

        {image.length > 1 && list?.length !== 0 && !table ? (
          <div className="ArrowBlockAllR ArrowBlockAll">
            <div className="ArrowBlockAll_NotCenter"></div>
            <div
              className="ArrowBlockAll_Center_Right"
              onClick={() => OnCountChange("-")}
            >
              <img
                src={ARROWRIGHT}
                className="ArrowBlockAll_Center_img"
                alt=""
              />
            </div>
            <div className="ArrowBlockAll_NotCenter"></div>
          </div>
        ) : null}
        {/*Стрелка вправо, если нужна */}

        {table ? (
          // eslint-disable-next-line react/jsx-no-comment-textnodes
          <div className="modal_table">
            <div className="attachment_button_group">
              {
                // eslint-disable-next-line array-callback-return
                table.rows.map((e, i) => {
                  // eslint-disable-next-line no-lone-blocks
                  {
                    if (table.rows.length > 1) {
                      return (
                        //@ts-ignore
                        <button
                          key={i}
                          className={
                            attachment === i
                              ? "attachment_button_selected"
                              : "attachment_button"
                          }
                          onClick={() => setAttachment(i)}
                        >
                          <span>({i + 1}) </span>
                          <div> &nbsp;{e.title}</div>
                        </button>
                      );
                    }
                  }
                })
              }
            </div>
            <div className="tableCutter">
              <table
                style={{
                  // tableLayout: "fixed",

                  display: "flex",
                  boxSizing: "border-box",
                  flexDirection: "column",
                }}
              >
                <thead>
                  {/* <tr className="tableTitle">
                    <td
                      colSpan={table.rows[attachment].columns.length}
                      style={{ fontWeight: 700 }}
                    >
                      {table.rows[attachment].title}
                    </td>
                  </tr> */}
                  <tr style={{ verticalAlign: "top" }}>
                    {table.rows[attachment].showhead === true ? (
                      table.tableheads.map((e, i) => {
                        return (
                          <td key={i} style={{ width: e.width }}>
                            {e.content}
                          </td>
                        );
                      })
                    ) : (
                      <></>
                    )}
                  </tr>
                </thead>
                <tbody style={{ display: "flex", flexDirection: "column" }}>
                  {table.rows[attachment].columns.map((e, i) => {
                    return (
                      <tr key={i}>
                        {e.map((e, i) => {
                          return (
                            <td
                              key={i}
                              className="td-table"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                whiteSpace: "break-spaces",
                                verticalAlign: "middle",
                                textAlign: "center",
                                boxShadow: "none",
                                borderTop: `${
                                  e.borderTop ? e.borderTop : null
                                }`,
                                width: `${e.width ? e.width : "100%"}`,
                                minWidth: `${e.minWidth ? e.minWidth : "5vw"}`,
                                height: `${e.height ? e.height : null}`,
                                backgroundColor: `${e.color ? e.color : null}`,
                                color: `${e.colorValue ? e.colorValue : null}`,
                                borderBottom: `${
                                  e.borderButton ? e.borderButton : null
                                }`,
                                borderRight: `${
                                  e.borderRIght ? e.borderRIght : null
                                }`,
                                border: `${e.border ? e.border : null}`,
                                padding: `${e.padding ? e.padding : null}`,
                                borderLeft: `${
                                  e.borderLeft ? e.borderLeft : null
                                }`,
                                borderCollapse: "collapse",
                                paddingRight: `${
                                  e.paddingRight ? e.paddingRight : null
                                }`,
                              }}
                            >
                              {e.content}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div
              className="ph_modal_table_block_second"
              style={
                table.rows[attachment].tableContent[0] === "" &&
                table.rows[attachment].tableText[0] === ""
                  ? { display: "none" }
                  : { display: "flex" }
              }
            >
              {table.rows[attachment].tableContent &&
              table.rows[attachment].tableContent[0] !== "" ? (
                <div className="ph_modal_table_image_block">
                  <img
                    className="ph_modal_table_image"
                    src={
                      table.rows[attachment].tableContent
                        ? table.rows[attachment].tableContent[0]
                        : ""
                    }
                    alt=""
                  />
                </div>
              ) : null}
              {table.rows[attachment].tableText &&
              table.rows[attachment].tableText[0] !== "" ? (
                <div className="ph_modal_table_text_block">
                  <p className="ph_modal_table_text">
                    {/* //HARDCODE EXTREAM */}
                    {table.rows[attachment].tableText[0] ===
                    "Нормирование мотор шпинделей по ISO/TR 17243-1:2014" ? (
                      <p>
                        Нормирование <b>мотор-шпинделей</b> по ISO/TR
                        17243-1:2014
                      </p>
                    ) : table.rows[attachment].tableText[0] ===
                      "Промышленные машины номинальной мощностью более 15 кВт и номинальной скоростью от 120 до 1500 мин в ст. минус 1" ? (
                      <p>
                        Промышленные машины номинальной мощностью более 15 кВт и
                        номинальной <br></br> скоростью от 120 до 1500 мин в ст.
                        минус 1
                      </p>
                    ) : table.rows[attachment].tableText[0] ===
                      "Нормирование  шпинделей с прямым и ременным приводом по ISO/TR 17243-2:2017" ? (
                      <p>
                        Нормирование
                        <b>шпинделей с прямым и ременным приводом</b> по ISO/TR
                        17243-2:2017
                      </p>
                    ) : table.rows[attachment].tableText[1] !== undefined ? (
                      attachment === 0 ? (
                        table.rows[attachment].tableText[0]
                      ) : (
                        table.rows[attachment].tableText[1]
                      )
                    ) : (
                      table.rows[attachment].tableText[0]
                    )}
                  </p>
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
      <PhotoModalSecond
        text={forModal.text}
        title={forModal.title}
        content={forModal.content}
        active={modalActiveSecond}
        setActive={setModalActiveSecond}
      />
    </div>
  );
};
